import React, { useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import DashboardHeader from '../components/DashboardHeader';
import FneEnvBanner from '../components/FneEnvBanner';
import { cn } from '../lib/utils';

/** Layout Admin (sidebar collapsible persisté en localStorage). */
export const AdminLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    return localStorage.getItem('sidebar_collapsed') === 'true';
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed((prev) => {
      localStorage.setItem('sidebar_collapsed', !prev);
      return !prev;
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminSidebar
        collapsed={sidebarCollapsed}
        onToggle={toggleSidebar}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className={cn('transition-all duration-300', 'lg:ml-64', sidebarCollapsed && 'lg:ml-16')}>
        <DashboardHeader onMenuClick={() => setMobileOpen(true)} sidebarCollapsed={sidebarCollapsed} />
        <FneEnvBanner />
        <main className="pt-16 sm:pt-20 p-3 sm:p-6">{children}</main>
      </div>
    </div>
  );
};
